import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { UploadInfo } from 'guploadmgr';



@Component({
  selector: 'app-upload-dialog',
  templateUrl: './dialog-upload.component.html',
  styleUrls: []
})
export class DialogUploadComponent implements OnInit {

  title = "";
  uploadinfo: UploadInfo = new UploadInfo();
  showAll = true;
  maxsizePerFile = 500000000;
  constructor() { }

  ngOnInit(): void {
  }


  public static openModalWithModel(dialog: MatDialog, title: string, uploadinfo: any, showAll: boolean = true, maxsizePerFile: number = 500000000, data?: any): MatDialogRef<DialogUploadComponent> {
    const dialogConfig = new MatDialogConfig();

    let width = window.innerWidth;
    let widthStr = "900px";
    if (width > 1400) {
      widthStr = "1100px";
    }
    else {
      widthStr = "950px";
    }

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = widthStr;
    dialogConfig.data = data;

    let dialogRef: MatDialogRef<DialogUploadComponent>;
    dialogRef = dialog.open(DialogUploadComponent, dialogConfig);
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.uploadinfo = uploadinfo;
    dialogRef.componentInstance.maxsizePerFile = maxsizePerFile;
    dialogRef.componentInstance.showAll = showAll;


    return dialogRef;
  }
}
